import { render, staticRenderFns } from "./ShowTemplate.vue?vue&type=template&id=c60365b2&scoped=true"
import script from "./ShowTemplate.vue?vue&type=script&lang=js"
export * from "./ShowTemplate.vue?vue&type=script&lang=js"
import style0 from "./ShowTemplate.vue?vue&type=style&index=0&id=c60365b2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c60365b2",
  null
  
)

export default component.exports